import React from 'react';
import { Field, reduxForm } from 'redux-form/immutable';
import PropTypes from 'prop-types';
import NavbarModulo from '../../components/NavbarModulo';
import DetalleTipoGasto from './DetalleTipoGasto';
import DetalleTipoGastoMod from './DetalleTipoGastoMod';
import DetalleTipoGastoVer from './DetalleTipoGastoVer';
import styled from 'styled-components';

import {
    renderField,
    AsyncSelectField
} from "../../Utils/renderField/renderField";

function TipoGastoForm(props) {
    const { 
        registroGasto, 
        crear, 
        modulo,
        modificarGasto, 
        listarCuentasContables, 
        detalleTipoGasto,
        detalleTipo,
        agregarLinea,
        agregarLineaCuenta,
        eliminarLinea,
        eliminarLineaCuenta
    } = props;
    
    const editar = window.location.href.includes('editar');
    let titulo = editar ? 'Modificar tipo de gasto' : 'Crear tipo de gasto';
    let disabled = false;
    if (crear === false && editar === false) {
        disabled = true;
        titulo = 'Ver tipo de gasto';
    }
    let autoFocus = true;
    let ruta = window.location.href;
    let id_emp = ruta.split('/');
    const estilo = {
        overflow: "auto",
        height: "300px",
    };
    return (
        <div>
            <NavbarModulo
                modulo={modulo}
                titulo={titulo}
            />
            <br />
            <div className="mb-4 card card-small text-white bg-dark mb-3">
                <div className="p-0 pt-3 d-flex flex-column flex-md-row">
                    <div className="d-flex flex-column flex-1 mx-4">
                        <div className='mb-2 row'>
                            <div className='col-8'>
                                <Field
                                    autoFocus={autoFocus}
                                    name="descripcion"
                                    placeholder="Descripción"
                                    className="form-control"
                                    component={renderField}
                                    disabled={disabled}
                                    msj="Descripción"
                                />
                            </div>
                        </div>
                        <h5 className="p-2 bg-secondary title mt-1">Cuentas contables</h5>
                        {(crear === true || editar === true) &&
                            <div className='mb-2 row'>
                                <div className='col-8'>
                                    <Field
                                        name="cuenta"
                                        placeholder="Cuenta contable..."
                                        className="form-control-find"
                                        component={AsyncSelectField}
                                        loadOptions={listarCuentasContables}
                                        msj="Cuenta contable"
                                    />
                                </div> 
                            </div>
                        }
                        {(crear === true) &&
                            <Contenido>
                                <button
                                    className='btn mr-2 mt-3 btn-primary'
                                    onClick={() => agregarLinea()}
                                >
                                    Agregar linea
                                </button>
                            </Contenido>
                        }
                        {(editar === true) &&
                            <Contenido>
                                <button
                                    className='btn mr-2 mt-3 btn-primary'
                                    onClick={() => agregarLineaCuenta()}
                                >
                                    Agregar linea
                                </button>
                            </Contenido>
                        }
                        <br/>
                        {crear === true &&
                            <div style={estilo}>
                                <DetalleTipoGasto
                                    detalle={detalleTipo}
                                    eliminarLinea={eliminarLinea}
                                />
                            </div>
                        }
                        {editar === true &&
                            <div style={estilo}>
                                <DetalleTipoGastoMod
                                    detalle={detalleTipoGasto}
                                    eliminarLinea={eliminarLineaCuenta}
                                />
                            </div>
                        }
                        {(crear === false && editar === false) &&
                            <div style={estilo}>
                                <DetalleTipoGastoVer
                                    detalle={detalleTipoGasto}
                                />
                            </div>
                        }
                        <div className='d-flex flex-row mt-3'>
                            {crear === true && editar === false &&
                                <button
                                    className='btn mr-2 mb-3 btn-primary'
                                    type='submit'
                                    onClick={registroGasto}
                                >
                                    Guardar
                                </button>
                            }
                            {crear === false && editar === true &&
                                <button
                                    className='btn mr-2 mb-3 btn-primary'
                                    type='submit'
                                    onClick={modificarGasto}
                                >
                                    Modificar
                                </button>
                            }
                            <a
                                href={`/#/visitador_medico/${id_emp[5]}/tipo_gasto`}
                                className='btn btn-secondary mb-3'
                            >
                                Regresar
                            </a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

TipoGastoForm.propTypes = {
    crear: PropTypes.bool,
    lectura: PropTypes.object,
    modulo: PropTypes.object,
};

const Contenido = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;

`;

export default reduxForm({
    form: 'FormTipoGastoVM',
    
})(TipoGastoForm);


